// extracted by mini-css-extract-plugin
module.exports = {"root":"Banner_root__R0fkV","ayurvedaBanner":"Banner_ayurvedaBanner__6kDGM"};